import React from 'react';
import { useTranslation } from 'react-i18next';
import { palette } from '../../styles/theme';

export function NoRecordsFoundMessage ({ entities }) {
    const list = entities === null ? [] : entities;
    const { t } = useTranslation();

    return (
        <>
            {list.length === 0 && entities !== null && (
                <div className='text-center' style={{ color: palette.disabled.main }}>{t('pagination.empty')}</div>
            )}
        </>
    );
}
